import React from "react";
//import ReactToPrint from "react-to-print";

class ComponentToPrint extends React.Component {
  constructor(){
    super();
    this.state = {
      forma_pago :"",
      razon_social :"CONSUMIDOR FINAL",
      ruc:"9999999999999",
      telefono:"S/N",
      direccion:"S/N",
      email:"S/N",
      alias:"",
      total_precio:0,
      costo_delivery:0,
      total_final:0,
      lista_items:[],
      fecha_creacion:'',
      cod_pedido:'',
      lon:0,
      lat:0,
      direccion_entrega:'',
      referencia_entrega:'',
      descuento:""
    }
  }

  // Convierte "a | b | c" en líneas con <br/>
  renderPipesAsLines = (text) => {
    const parts = String(text || '')
      .split('|')
      .map(s => s.trim())
      .filter(Boolean);

    if (!parts.length) return null;

    return (
      <>
        {parts.map((line, i) => (
          <React.Fragment key={i}>
            {line}{i < parts.length - 1 ? <br/> : null}
          </React.Fragment>
        ))}
      </>
    );
  };

  get_Pedido =()=>{
    const url= this.props.dir_url + "webapp/getDatosDetallePedido";
    const token =  this.props.token
    const token_Pedido =  this.props.token_pedido
    var obj = { accion:'datosdetallepedido', token, token_Pedido};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          lon:data[0].msg[0].lon,
          lat:data[0].msg[0].lat,
          forma_pago:data[0].msg[0].forma_pago,
          razon_social:data[0].msg[0].razon_social,
          ruc:data[0].msg[0].ruc,
          telefono:data[0].msg[0].telefono,
          direccion:data[0].msg[0].direccion,
          email:data[0].msg[0].correo_electronico,
          alias:data[0].msg[0].alias,
          total_final:data[0].msg[0].total,
          costo_delivery:data[0].msg[0].delivery,
          fecha_creacion:data[0].msg[0].fecha_creacion,
          cod_pedido:data[0].msg[0].cod_pedido,
          lista_items:data[0].msg,
          direccion_entrega:data[0].msg[0].direccion_entrega,
          referencia_entrega:data[0].msg[0].referencia_entrega,
          descuento:data[0].descuento
        })
      }
    })
    .catch(console.log)
  }

  getDetalleComboPrecio=(adicionales_json)=>{
    if(adicionales_json){
      let adicional_array = JSON.parse(adicionales_json)
      let precio_adicional = 0
      adicional_array.forEach(cp_detalle => {
        if(cp_detalle.complemento==='Combo'){
          cp_detalle.CDetalle.forEach(() => {})
        }else{
          if(cp_detalle.complemento==='Adicional'){
            let descuento_var = cp_detalle.descuento ? Number(cp_detalle.descuento) : 0;
            precio_adicional += (Number(cp_detalle.precio) - descuento_var).toFixed(2) * Number(cp_detalle.cant);
          }
        }
      })
      return precio_adicional
    }else{
      return 0
    }
  }

  getDetalleCombo=(descripcion_ad,adicionales_json,adicionales)=>{
    let descripcion = descripcion_ad
    if(adicionales){
      adicionales.forEach(cp_detalle => {
        descripcion = descripcion + ""+ cp_detalle.cantidad + 'x '+ cp_detalle.producto + ' ' + cp_detalle.precio_neto + '$'
      })
    }

    if(adicionales_json){
      let adicional_array = JSON.parse(adicionales_json)
      let descripcion = ''
      adicional_array.forEach(cp_detalle => {
        if(cp_detalle.complemento==='Combo'){
          cp_detalle.CDetalle.forEach(cp_detalle_combo => {
            if(descripcion!=='') descripcion = descripcion + ' + '
            descripcion = descripcion + cp_detalle_combo.cant + 'x '+ cp_detalle_combo.producto
          })
        }else{
          if(descripcion!=='') descripcion = descripcion + ' + '
          if(cp_detalle.complemento==='Adicional'){
            if(Number(cp_detalle.descuento)>0){
              descripcion = descripcion  + cp_detalle.cant + 'x '+ cp_detalle.producto + ' ' + cp_detalle.precio + '$ -(' + cp_detalle.descuento + '$)'
            }else{
              descripcion = descripcion  + cp_detalle.cant + 'x '+ cp_detalle.producto + ' ' + cp_detalle.precio + '$'
            }
          }else{
            descripcion = descripcion +  cp_detalle.producto
          }
        }
      })
      return <>{descripcion}</>
    }else{
      return <>{descripcion}</>
    }
  }

  render() {
    const lista_items = this.state.lista_items
    return (
      <>
        <div id="seleccion"  style={{height:"100%", width: "100%"}}>
          <div style={{width:"280px", backgroundColor:"white", color:"black"}}>
            <div style={{height:"20px", width:"100%"}}>
              <div style={{height:"20px", width:"100%", justifyContent:"center", alignItems:"center", display:"flex"}}>
                <b>DATOS DEL PEDIDO</b>
              </div>
            </div>
            <div style={{height:"20px", width:"100%"}}>
              <div style={{height:"20px", width:"100%"}}>
                Fecha: {this.state.fecha_creacion}
              </div>
            </div>
            <div style={{height:"20px", width:"100%"}}>
              <div style={{height:"20px", width:"100%"}}>
                Pedido: {this.state.cod_pedido}
              </div>
            </div>

            {/* DIRECCIÓN + referencia, con pipes en líneas */}
            <div style={{width:"100%"}} >
              <div style={{width:"100%"}}>
                <b>DIRECCIÓN:</b><br/>
                {this.renderPipesAsLines(this.state.direccion_entrega)}
                {this.state.direccion_entrega ? <br/> : null}
                {this.renderPipesAsLines(this.state.referencia_entrega)}
              </div>
            </div>

            <div style={{width:"100%", height:"40px", borderBottom:"1px solid #000"}}>
              <div style={{height:"20px", width:"100%", justifyContent:"center", alignItems:"center", display:"flex"}}>
                <b>PRODUCTOS</b>
              </div>
            </div>

            <>
              {lista_items.map((item , index) => (
                <div key={index} style={{width:"100%", borderBottom:"1px solid #000"}}>
                  <div style={{width:"100%", display:"flex",flexDirection:"column",alignItems:"center"}}>
                    <b>{item.producto}</b>
                    {(item.observacion)?<React.Fragment><span style={{color:"red"}}>*** {item.observacion}</span></React.Fragment>:null}
                  </div>
                  <div style={{width:"100%", justifyContent:"center", alignItems:"center", display:"flex"}}>
                    <div  style={{width:"10%", height:"100%"}}>
                      {item.cantidad+"x"}
                    </div>
                    <div style={{width:"70%", height:"100%"}}/>
                    <div style={{width:"20%", height:"100%", textAlign:"right"}}>
                      ${Number(Number(item.precio_neto)+this.getDetalleComboPrecio(item.adicionales_json)).toFixed(2)}
                    </div>
                  </div>
                  <div style={{width:"100%",  justifyContent:"center", alignItems:"center", display:"flex"}}>
                    {this.getDetalleCombo(item.descripcion,(item.adicionales_json),item.adicionales)}
                  </div>
                </div>
              ))}
            </>

            <div style={{height:"20px", width:"100%"}}>
              <div style={{justifyContent:"center", alignItems:"center", display:"flex", height:"20px", width:"100%"}}>
                <b>FORMA DE PAGO</b>
              </div>
            </div>
            <div style={{height:"20px", width:"100%"}}>
              <div style={{height:"20px", width:"100%"}}>
                {this.state.forma_pago}
              </div>
            </div>

            <div style={{height:"20px", width:"100%"}}>
              <div style={{justifyContent:"center", alignItems:"center", display:"flex", height:"20px", width:"100%"}}>
                <b>DATOS DEL COMPROBANTE</b>
              </div>
            </div>
            <div style={{height:"20px", width:"100%"}}>
              <div style={{height:"20px", width:"100%"}}>
                Nombre: {this.state.razon_social}
              </div>
            </div>
            <div style={{height:"20px", width:"100%"}}>
              <div style={{height:"20px", width:"100%"}}>
                Código: {this.state.ruc}
              </div>
            </div>
            <div style={{height:"20px", width:"100%"}}>
              <div style={{height:"20px", width:"100%"}}>
                Teléfono: {this.state.telefono}
              </div>
            </div>
            <div style={{height:"20px", width:"100%"}}>
              <div style={{height:"20px", width:"100%"}}>
                Dirección: {this.state.direccion}
              </div>
            </div>
            <div style={{height:"20px", width:"100%"}}>
              <div style={{height:"20px", width:"100%"}}>
                Email: {this.state.email}
              </div>
            </div>

            <div style={{height:"35px", width:"100%", borderBottom:"1px solid #000", justifyContent:"center", alignItems:"center", display:"flex"}}>
              <div style={{height:"35px", width:"70%"}}>Descuento</div>
              <div style={{height:"35px", width:"30%", textAlign:"right"}}>${Number(this.state.descuento).toFixed(2)}</div>
            </div>
            <div style={{height:"35px", width:"100%", borderBottom:"1px solid #000", justifyContent:"center", alignItems:"center", display:"flex"}}>
              <div style={{height:"35px", width:"70%"}}>Transporte</div>
              <div style={{height:"35px", width:"30%", textAlign:"right"}}>${Number(this.state.costo_delivery).toFixed(2)}</div>
            </div>
            <div style={{height:"35px", width:"100%", borderBottom:"1px solid #000", justifyContent:"center", alignItems:"center", display:"flex"}}>
              <div style={{height:"35px", width:"70%"}}>Total Comprobante</div>
              <div style={{height:"35px", width:"30%", textAlign:"right"}}>${Number(this.state.total_final).toFixed(2)}</div>
            </div>
          </div>
        </div>
      </>
    );
  }

  componentDidMount (){
    this.get_Pedido()
  }
}

class getVistaPrevia extends React.Component {
  render() {
    return (
      <div style={{width:"100%", height:"100%", backgroundColor:"white"}}>

        <div className="cssversion_pw100 cssversion_pxh10 cssversion_colorblanco" style={{display:"flex"}}>
          <div className="cssversion_pw80" style={{justifyContent:"center", alignItems:"center", display:"flex"}}>
            <span className="span-global-link" onClick={ () => this.props.imprimir("seleccion") } >Presione aquí para Imprimir Pedido</span>
          </div>
          <div className="cssversion_pw20" style={{justifyContent:"center", alignItems:"center", display:"flex"}}>
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } onClick={ () => this.props.get_aceptar_pedido( this.props.token_pedido)} />
          </div>
        </div>

        <ComponentToPrint
          token_pedido={this.props.token_pedido}
          token={this.props.token}
          dir_url={this.props.dir_url}
          ref={el => (this.componentRef = el)}
        />
      </div>
    );
  }
}
/*<!--
<ReactToPrint
  trigger={() => <a href="#">Click para Imprimir</a>}
  content={() => this.componentRef}
/>-->*/
export default getVistaPrevia;
